import Vue from "vue";

// 节流指令
// parameters 调用函数时传的数据
// time 节流时间
// fun 调用的函数

Vue.directive("throttle", {
  bind: function(el, binding) {
    let throttleTime = 2000; // 节流时间
    if (binding.value.time) {
      throttleTime = binding.value.time;
    }
    const throttleFun = binding.value.fun;
    let cbFun = "";
    el.addEventListener(
      "click",
      () => {
        if (!cbFun) {
          if (binding.value.parameters) {
            throttleFun(binding.value.parameters);
          } else {
            throttleFun();
          }
          cbFun = setTimeout(() => {
            cbFun = null;
          }, throttleTime);
        }
      },
      true
    );
  }
});
// 防抖指令
Vue.directive("debounce", {
  bind: function(el, binding) {
    let debounceTime = 1000; // 节流时间
    if (binding.value.time) {
      debounceTime = binding.value.time;
    }
    const debounceFun = binding.value.fun;
    let cbFun = "";
    el.addEventListener(
      "input",
      () => {
        clearTimeout(cbFun);
        cbFun = setTimeout(() => {
          cbFun = null;
          debounceFun();
        }, debounceTime);
      },
      true
    );
  }
});

/*
*不能输入中文和中文字符
*/
import onlyNumber from './onlyNumber'
Vue.directive('floatNumber', onlyNumber)




